import React from 'react'
import { Select, TreeSelect } from 'antd';
import { CInputGroup, CInputGroupText, CFormInput } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilCloudDownload, cilTrash } from '@coreui/icons';
import "./styles/WidgetCustomerSelector.css"
export default function WidgetCustomerSelector({ customers, value, onChange, reloadDropdownData, viewOnly, displayValue, width = '100%', showCloudIcon = true, height, placeholder = "Select Customer" }) {

  const filterOption = (input, option) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  return (

    <>
      {(+value > 0 && displayValue !== "") || viewOnly ? (
        <React.Fragment >
          <CInputGroup>
            <CFormInput value={displayValue} placeholder={placeholder} disabled />
            {!viewOnly && (
              <CInputGroupText
                style={{ cursor: 'pointer' }}
                onClick={() => onChange(null)}
              >
                <CIcon icon={cilTrash} alt="Remove" title="Remove" />
              </CInputGroupText>
            )}
          </CInputGroup>
        </React.Fragment >

      ) : (
        <CInputGroup style={{ height: 30 }}>
          <div style={{ flexGrow: 1 }}>
            <Select
              showSearch
              placeholder="Select a Customer"
              optionFilterProp="children"
              onChange={onChange}
              filterOption={filterOption}
              options={customers}
              allowClear
              disabled={viewOnly}
              style={{ width: width, height: height }}
              value={value}
            />

          </div>
          {showCloudIcon && (
            <>
              <CInputGroupText
                style={{ cursor: 'pointer' }}
                onClick={() => reloadDropdownData()}
              >
                <CIcon icon={cilCloudDownload} alt="Sync" title="Sync" />
              </CInputGroupText>
            </>
          )}
        </CInputGroup>
      )}
    </>
  )
}
